/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { MeetingInfo } from './MeetingService';
import { buildTelemetryUrl } from './UrlService';

// parameters documented here: https://bitbucket.ops.expertcity.com/projects/LNCH/repos/launcher-service/browse/launcher-service-v2/src/main/java/com/citrix/launcher/web/HelperParameters.java
export interface LaunchParameters {
  iat: number;
  launchParams: {
    build: string;
    compatibleBuilds: string;
    telemetryURL: string;
    endpointParams: {
      Action: string;
      MeetingID?: string;
      Product: string;
      sessionTrackingId: string;
      authorizationCode?: string;
    };
  };
  version: string;
}

export interface LaunchTokenHeader {}

// parameters documented here: https://confluence.ops.expertcity.com/display/~ivang/Command+Line+Parameters+Used+by+GoToMeeting+Desktop+EP
export const makeLaunchParametersFromMeetingInfo = (
  meetingInfo: MeetingInfo,
  meetingId: string | undefined,
  stId: string,
  telemetryToken: string
): LaunchParameters => ({
  iat: Math.round(new Date().getTime() / 1000),
  launchParams: {
    build: meetingInfo.build,
    compatibleBuilds: meetingInfo.nativeEPCompatibleVersions,
    telemetryURL: buildTelemetryUrl(telemetryToken),
    endpointParams: {
      Action: 'Join',
      Product: 'g2m',
      sessionTrackingId: stId,
      MeetingID: meetingId,
      authorizationCode: meetingInfo.authorizationCode,
    },
  },
  version: '1.0',
});
